import React, { useState } from "react";
import "./TopBar.css";

import { Link } from "react-router-dom";
import { QrScanner } from "react-qr-barcode-scanner";
//import QrScanner from "react-qr-barcode-scanner";
import { useNavigate } from "react-router-dom";
// images
import { ReactComponent as SlotCloseIcon } from "../../assets/svg/close-1.svg";
import { ReactComponent as RefreshIcon } from "../../assets/svg/refresh-icon.svg";
import SignOut from "../../assets/svg/signout.svg";
import logo_icon from "../../assets/svg/logo_icon.svg";
import gate_icon from "../../assets/svg/Gate new logo-02 1.svg";
import v_arrow from "../../assets/svg/v_Arrow.svg";
import issue_image from "../../assets/svg/issue_image.svg";
import scan_icon from "../../assets/svg/scan_icon.svg";
import { ReactComponent as bell_icon } from "../../assets/svg/bell_icon.svg";
import { ReactComponent as SettingIcon } from "../../assets/svg/seetingIc.svg";
import { ReactComponent as HelpIcon } from "../../assets/svg/helpIcon1.svg";
import { ReactComponent as SettingIconOrg } from "../../assets/svg/SettingIconOrg.svg";
import ProfileImg from "../../assets/png/user-icon.png";
import login_icon from "../../assets/svg/login_icon.svg";
import drop from "../../assets/svg/drop.svg";
import setting_icon from "../../assets/svg/setting_icon.svg";
import Dropdown from "react-bootstrap/Dropdown";
import { useEffect, useRef } from "react";
import { format, parse } from "date-fns";
import { getbasicDetAPi, getcheckAPi, getOrgLogoApi } from "./topbar-api";
// import { TabProvider } from "./common/context/tabContext";
import { useTab } from "../common/context/tabcontext";
import ComplaintModal from "../modal-dialog/complaint-modal";
import ModalCloseIcon from "../../assets/svg/close-modal.svg";
import microsoft from "../../assets/svg/microsoft.svg";
import apple from "../../assets/svg/apple.svg";
import android from "../../assets/svg/android.svg";
import ReportAnIssueModal from "../modal-dialog/report-an-issue-modal";
import { Modal } from "react-bootstrap";
import LogoutModal from "../modal-dialog/signout-model";
import { useGlobal } from "../../GlobalContext.js";

const TopBar = (currentName) => {

  const [hovered, setHovered] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const popupRef = useRef();

  // Close popup when clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPopup(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const { rolePermissionList, userType } = useGlobal();
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;

  const [orgLogo, setOrgLogo] = useState(false);
  const { headerDetails, setheaderDetails } = useTab();
  const [showComplaintModule, setShowComplaintModule] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [ishelpHovered, setIshelpHovered] = useState(false);
  const [isSetHovered, setIsSetHovered] = useState(false);
  const [displayMessage, setDisplayMessage] = useState(null);
  const [isScannerActive, setIsScannerActive] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const navigate = useNavigate();
  const [scanData, setScanData] = useState("");
  const [openProfile, setOpenProfile] = React.useState(false);
  const [openNotify, setOpenNotify] = React.useState(false);
  const dropdownRef = useRef(null);
  const [show, setShow] = useState(false);
  const dropdownDownloadRef = useRef(null);
  const [showDownload, setShowDownload] = useState(false);
  // const [headerDetails, setHeaderDetails] = useState({});
  const [logoutModalVisible, setLogoutModalVisible] = useState(false);
  const handleProfileOpen = () => {
    getbasicDetails();
    setOpenProfile(true);
    console.log(openProfile);
  };
  const handleProfileClose = () => {
    setOpenProfile(false);
  };
  const handleNotifyClose = () => {
    setOpenNotify(false);
  };
  useEffect(() => {
    getOrgLogo();
    if (!headerDetails || Object.keys(headerDetails).length === 0) {
      getbasicDetails();
    }

    setActive(currentName.currentName);
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShow(false);
      }
      if (dropdownDownloadRef.current && !dropdownDownloadRef.current.contains(event.target)) {
        setShowDownload(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const closeModal = () => {
    setIsScannerActive(false);
    setIsOpen(false);
  };
  const handleNavigate = (type) => {
    if (type === "Visitor") {
      navigate("/visitor-create");
      setActive("visitor");
    }
    if (type === "Vehicle") {
      navigate("/vehicle-create");
      setActive("vehicle");
    }
    if (type === "Courier") {
      navigate("/courier-create");
      setActive("courier");
    }
  };
  const handletabNavigate = (type) => {
    if (type === "dashboard") navigate("/dashboard");
    if (type === "visitor") navigate("/visitors");
    if (type === "vehicle") navigate("/vehicle");
    if (type === "courier") navigate("/courier");
    if (type === "report") navigate("/report");
  };

  const handleScan = (result) => {
    console.log("scan data........", result);
    if (result) {
      setDisplayMessage("Please wait...");
      setIsScannerActive(false);
      console.log("scan data........", result.text);
      setScanData(result.text);
      checkQRCode(result.text);
    }
  };

  const getbasicDetails = async () => {
    try {
      const response = await getbasicDetAPi();
      if (response.success === true) {
        setheaderDetails(response.user ?? {});
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getOrgLogo = async () => {
    try {
      const response = await getOrgLogoApi();
      if (response.success === true) {
        /*  setheaderDetails(response.user ?? {}); */
        setOrgLogo(response.image ?? "");
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const checkQRCode = async (url) => {
    try {
      const response = await getcheckAPi(url)
        .then((response) => {
          console.log("enteredd", response);
          console.log("enteredd");
          if (response.success === true) {
            closeModal();
            if (response.Data.type === "Vehicle") {
              navigate("/vehicle-view", { state: { id: response.Data.id } });
            } else if (response.Data.type === "Visitor") {
              navigate("/visitor-view", { state: { id: response.Data.id } });
            }
          }
        })
        .catch((error) => {
          if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Data:", error.response.data);
            if (error.response.status === 500 || error.response.status === 400) {
              var errorMsg = error.response.data.error;
              setErrorMessage("Invalid QR Code!");
              setIsScannerActive(true);
              console.log("error msg", errorMsg);
            }
          } else {
            console.error("Request failed:", error.message);
          }
        });

      // const data = await response.json();
    } catch (err) {
      console.error("Error fetching floors:", err);
    } finally {
    }
  };
  const handleError = (err) => {
    console.error("Scan error:", err);
    /* setErrorMessage("No QR code detected. Try again."); */
  };
  const openModal = () => {
    console.log("open modal called");

    setIsOpen(true);
    setIsScannerActive(true);
  };
  const restartScanner = () => {
    setDisplayMessage("Restarting scanner...");
    setIsScannerActive(false); // Unmount scanner
    setTimeout(() => setIsScannerActive(true), 100); // Remount scanner after a short delay
    setScanData(null); // Reset the scan result
    setErrorMessage(null); // Clear any error messages
  };
  function formatDate(inputDate) {
    if (inputDate !== undefined) {
      // Parse the input date (MM/DD/YYYY format)
      const parsedDate = parse(inputDate, "MM/dd/yyyy", new Date());

      // Format the date
      return format(parsedDate, "EEEE, dd MMM yyyy");
    } else {
      return "";
    }
  }
  const { active, setActive } = useTab();
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.1)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "16px 24px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0)",
      width: "365px",
      height: "474px",
      textAlign: "center",
    },
  };
  const getTabStyle = (isActive) => ({
    cursor: "pointer",
    fontSize: "14px",
    fontFamily: "'Space Grotesk'",
    fontWeight: isActive ? "600" : "500",
    height: "40px",
    color: isActive ? "#2C8C53" : "#44546F",
    borderBottom: isActive ? "3px solid #2C8C53" : "3px solid transparent",
    paddingBottom: "0px",
  });

  const complaintStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",

      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "680px",

      overflowY: "auto",
    },
  };
  const onSuccess = (response) => {
    setShowComplaintModule(false);
  };
  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex((element) => element["name"] === menuName && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
  }
  return (
    <>
      <div className="topbar">
        {/* Left side - Logos + Navigation Links */}
        <div className="topbar-left">
          <img
            src={logo_icon}
            alt="Company Logo"
            className="logo"
            onClick={() => {
              window.open(accountsUrl, "_blank", "noopener,noreferrer");
            }}
          />
          <img src={orgLogo != null && orgLogo !== "" ? orgLogo : gate_icon} alt="" className="gate-icon" />

          {/* Navigation starts right after gate-icon */}
          <nav className="topbar-nav">
            {(checkPermission("Dashboard", "menu_permission") || userType === "A" || userType === "SA") && (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "bottom", padding: "25px 16px 11px" }}>
                <div
                  onClick={() => {
                    setActive("dashboard");
                    handletabNavigate("dashboard");
                  }}
                  style={getTabStyle(active === "dashboard")}>
                  Dashboard
                </div>
              </div>
            )}
            {(checkPermission("Visitor", "menu_permission") || userType === "A" || userType === "SA") && (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "bottom", padding: "25px  16px 11px" }}>
                <div
                  onClick={() => {
                    setActive("visitor");
                    handletabNavigate("visitor");
                  }}
                  style={getTabStyle(active === "visitor")}>
                  Visitors
                </div>
              </div>
            )}
            {(checkPermission("Vehicle", "menu_permission") || userType === "A" || userType === "SA") && (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "bottom", padding: "25px  16px 11px" }}>
                <div
                  onClick={() => {
                    setActive("vehicle");
                    handletabNavigate("vehicle");
                  }}
                  style={getTabStyle(active === "vehicle")}>
                  Vehicles
                </div>
              </div>
            )}
            {(checkPermission("Courier", "menu_permission") || userType === "A" || userType === "SA") && (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "bottom", padding: "25px  16px 11px" }}>
                <div
                  onClick={() => {
                    setActive("courier");
                    handletabNavigate("courier");
                  }}
                  style={getTabStyle(active === "courier")}>
                  Couriers
                </div>
              </div>
            )}
            {(checkPermission("Report", "menu_permission") || userType === "A" || userType === "SA") && (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "bottom", padding: "25px  16px 11px" }}>
                <div
                  onClick={() => {
                    setActive("report");
                    handletabNavigate("report");
                  }}
                  style={getTabStyle(active === "report")}>
                  Report
                </div>
              </div>
            )}
            {/* {[
            { label: "Dashboard", path: "/" },
            { label: "Visitors", path: "/visitors" },
            { label: "Vehicles", path: "/vehicle" },
            { label: "Courier", path: "/courier" },
          ].map(({ label, path }) => (
            <Link
              key={path}
              to={path}
              className={activeLink === path ? "active visitor-active" : ""}
              onClick={() => setActiveLink(path)}
            >
              {label}
            </Link>
          ))} */}
            <div ref={dropdownRef}>
              <Dropdown show={show} onToggle={() => setShow(!show)}>
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <span style={{ fontSize: "15px", fontWeight: "600", color: "#fff", fontFamily: "Epilogue" }}>Create</span>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  style={{
                    border: "none",
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                    width: "200px",
                    borderRadius: "8px",
                    padding: "12px 12px",
                  }}
                  align="start">
                  <Dropdown.Item
                    align="start"
                    style={{
                      borderRadius: "6px",
                    }}
                    onClick={() => handleNavigate("Visitor")}>
                    Visitor
                  </Dropdown.Item>
                  <Dropdown.Item
                    style={{
                      borderRadius: "6px",
                    }}
                    onClick={() => handleNavigate("Vehicle")}>
                    Vehicle
                  </Dropdown.Item>
                  <Dropdown.Item
                    style={{
                      borderRadius: "6px",
                    }}
                    onClick={() => handleNavigate("Courier")}>
                    Courier
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </nav>
        </div>

        {/* Right side - Actions */}
        <div className="topbar-right">
          {/* Report an Issue - With Image */}
          <div
            className="report-issue"
            onClick={() => {
              setShowComplaintModule(true);
            }}>
            <img src={issue_image} alt="Report Icon" className="report-icon" />
            <span>Report an Issue</span>
          </div>

          {/* Download App Button with Arrow */}
          {/* <div className="download-app">
            <span>Download App</span>
            <img src={v_arrow} alt="Dropdown Arrow" />
          </div> */}

          {/* <div ref={dropdownDownloadRef}>
            <Dropdown show={showDownload} onToggle={() => setShowDownload(!showDownload)}>
              <Dropdown.Toggle as="button" className="download-app" id="dropdown-download">
                <span>Download</span>
              </Dropdown.Toggle>
              <Dropdown.Menu
                style={{
                  border: "none",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                  width: "200px",
                  borderRadius: "8px",
                  padding: "12px 12px",
                }}
                align="start">
                <Dropdown.Item
                  align="start"
                  style={{
                    borderRadius: "6px",
                  }}
                  onClick={() => {
                    window.open("https://play.google.com/store/apps/details?id=com.mawalog.gate", "_blank", "noopener,noreferrer");
                  }}>
                  Android
                </Dropdown.Item>
                <Dropdown.Item
                  style={{
                    borderRadius: "6px",
                  }}
                  onClick={() => {
                    window.open("https://apps.apple.com/us/app/gate-keeping/id6477543461", "_blank", "noopener,noreferrer");
                  }}>
                  IOS
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div> */}

          <div style={{ position: "relative", display: "inline-block" }} ref={popupRef}>
            <div onClick={() => setShowPopup(!showPopup)} style={{ backgroundColor: "#f8f8f8",  padding: "10px 16px", borderRadius: "12px", cursor: "pointer",  display:'flex',alignItems:'center',gap:"8px"}}>
              <div style={{fontSize: "13px", fontWeight: "500",color: "#172b4d"}}>
                Download
              </div>
              <img src={drop}/>
            </div>

            {/* Custom popup */}
            {showPopup && (
              <div style={{ borderRadius: "24px", padding: "16px", backgroundColor: "#ffffff", width: "250px",  position: "absolute", top: "150%", right: "-100px",boxShadow: "0px 6px 14px 0px #0000001A, 0px 25px 25px 0px #00000017, 0px 55px 33px 0px #0000000D, 0px 99px 39px 0px #00000003, 0px 154px 43px 0px #00000000" }}>
                <div style={{ fontWeight: "700", fontSize: "14PX", color: "#172B4D" }}>Download Gate app for</div>
                <div style={{ marginTop: "20px", display: "flex", alignItems: "center", gap: "32px" }}>
                  <div onMouseEnter={() => setHovered("android")} onMouseLeave={() => setHovered(null)} onClick={() => window.open("https://play.google.com/store/apps/details?id=com.mawalog.gate", "_blank", "noopener,noreferrer")} style={{ display: "flex", flexDirection: "column", gap: "10px",minWidth:'88px', alignItems: "center", cursor: "pointer", padding: "16px", borderRadius: "12px", backgroundColor: hovered === "android" ? "#F2FFF7" : "#f7f8f9" }}>
                    <img src={android} style={{ width: "22px" }} />
                    <div style={{ fontWeight: "500", fontSize: "13px", color: hovered === "android" ? "#2C8C53" : "#172B4D" }}>Android</div>
                  </div>

                  <div onMouseEnter={() => setHovered("ios")} onMouseLeave={() => setHovered(null)} onClick={() => window.open("https://apps.apple.com/us/app/gate-keeping/id6477543461", "_blank", "noopener,noreferrer")} style={{ display: "flex", flexDirection: "column", gap: "10px",minWidth:'88px', alignItems: "center", cursor: "pointer", padding: "16px", borderRadius: "12px", backgroundColor: hovered === "ios" ? "#F2FFF7" : "#f7f8f9" }}>
                    <img src={apple} style={{ width: "22px" }} />
                    <div style={{ fontWeight: "500", fontSize: "13px", color: hovered === "ios" ? "#2C8C53" : "#172B4D" }}>IOS</div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Scan Button */}
          <div
            className="scan-btn"
            onClick={() => {
              openModal();
            }}>
            <img src={scan_icon} alt="Scan Icon" className="scan-icon" />
            <span>Scan</span>
          </div>
          {/* <div className="scan-btn" onClick={() => { openModal() }} style={{ cursor: "pointer", width: '112px', height: '44px', borderRadius: '10px', display: 'flex', justifyContent: "center", alignItems: "center", backgroundColor: '#842234' }}>
          <div><ScanIcon /></div>&nbsp; <div style={{ fontSize: "16px", fontWeight: "500", color: '#FFFFFF' }}>Scan</div>
        </div>&nbsp;&nbsp;&nbsp; */}
          {/* Icons */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "12px", // spacing between icons
            }}>
            {/* 
          <div
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
              width: 44,
              height: 44,
              borderRadius: "100px",
              overflow: "hidden",
              cursor: "pointer",
              backgroundColor: isHovered ? "#F8F8F8" : "#fff", // example hover effect
              transition: "background-color 0.2s ease",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <SettingIcon />
          </div> */}
            <div
              onMouseEnter={() => setIshelpHovered(true)}
              onMouseLeave={() => setIshelpHovered(false)}
              onClick={() => {
                navigate("/help");
              }}
              style={{
                width: 44,
                height: 44,
                borderRadius: "100px",
                overflow: "hidden",
                cursor: "pointer",
                backgroundColor: ishelpHovered ? "#F8F8F8" : "#fff", // example hover effect
                transition: "background-color 0.2s ease",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
              <HelpIcon />
            </div>
            {checkPermission("Gate - Setup", "menu_permission") && checkPermission("Vehicletype - Setup", "menu_permission") && checkPermission("Purpose of visit - Setup", "menu_permission") && checkPermission("Checklist - Setup", "menu_permission") && (
              <div
                onMouseEnter={() => setIsSetHovered(true)}
                onMouseLeave={() => setIsSetHovered(false)}
                onClick={() => navigate("/gatemasters")}
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: "100px",
                  overflow: "hidden",
                  cursor: "pointer",
                  backgroundColor: isSetHovered ? "#F8F8F8" : "#fff", // example hover effect
                  transition: "background-color 0.2s ease",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <SettingIconOrg />
              </div>
            )}
            <div
              className="dprofile2"
              onClick={() => {
                handleProfileOpen();
                handleNotifyClose();
              }}>
              <img src={ProfileImg} style={{ width: "32px", height: "32px", borderRadius: "100px" }} className="profile2" alt="profile" />
            </div>
          </div>
        </div>

        {showComplaintModule && (
          <ReportAnIssueModal
            onSuccess={onSuccess}
            onCancel={() => {
              setShowComplaintModule(false);
            }}
          />
        )}
        {isOpen && (
          <div style={modalStyle.overlay}>
            <div style={modalStyle.modal}>
              <div style={{ color: "#ffffff" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "start" }}>
                    <div style={{ fontSize: "16px", fontWeight: "700", color: "#1E1E1E" }}>Place the QR code inside the area</div>
                  </div>
                </div>

                <div>
                  <div style={{ width: "320px", height: "320px", textAlign: "center" }}>
                    {isScannerActive ? (
                      <QrScanner
                        className="qr-image-wrapper"
                        width={320}
                        height={320}
                        onUpdate={(err, result) => {
                          console.log("scan data........", result);
                          if (result) handleScan(result);
                          else handleError(err);
                        }}
                        style={{
                          width: "320px",
                          height: "320px",
                          borderRadius: "16px",
                          overflow: "hidden", // optional, to keep corners clean
                        }}
                      />
                    ) : (
                      <div style={{ width: "320px", height: "320px", color: "#1E1E1E", display: "flex", alignItems: "center", justifyContent: "center" }}>{displayMessage}</div>
                    )}
                    {errorMessage && <div style={{ color: "red" }}>{errorMessage}</div>}
                  </div>
                  <div style={{ marginTop: "8px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <SlotCloseIcon onClick={closeModal} style={{ cursor: "pointer", width: "48px", height: "48px" }} /> <RefreshIcon onClick={restartScanner} style={{ cursor: "pointer", width: "48px", height: "48px" }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <LogoutModal
          isVisible={openProfile}
          onClose={() => setOpenProfile(false)}
          onConfirm={() => {
            document.cookie = "redirectPath=" + window.location.href + "; path=/; domain=.mawalog.com";
            document.cookie = "mawalog=; path=/; domain=.mawalog.com";
            window.location.href = accountsUrl;
          }}
          headerDetails={headerDetails}
        />
      </div>
    </>
  );
};

export default TopBar;
